import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const LS_CUBE_SORT_KEY = 'playerOverview-sort';

const loadInitialSort = (): string => {
    try { return localStorage.getItem(LS_CUBE_SORT_KEY) || ''; } catch { return ''; }
};

export interface SortState {
    cubeSort: string;
}

const initialState: SortState = {
    cubeSort: loadInitialSort(),
};

const sortSlice = createSlice({
    name: 'sort',
    initialState,
    reducers: {
        setCubeSort(state, { payload }: PayloadAction<string>) {
            state.cubeSort = payload;
            try { localStorage.setItem(LS_CUBE_SORT_KEY, payload); } catch { /* noop */ }
        },
    },
});

export const { setCubeSort } = sortSlice.actions;

export default sortSlice.reducer;
